import { LitElement, html, css } from 'lit';
import { property, query, customElement } from 'lit/decorators.js';

import { Account } from '../../types/types';
import { repeat } from 'lit/directives/repeat.js';

import '../../elements/langhout-button/langhout-button';
import '../../elements/langhout-checkbox/langhout-checkbox';
import { showNotification } from '../../LanghoutBetonPortal';
import {
  authenticatedAPICall,
  isSuccessfulAPIResponse,
} from '../../client/api-client';
import { closeIcon, minusIcon, plusIcon } from '../../elements/icons/icons';
import { sharedStyles } from '../../elements/shared-styles';
import { LanghoutCheckbox } from '../../elements/langhout-checkbox/langhout-checkbox';

@customElement('langhout-beton-edit-account')
export class EditAccount extends LitElement {
  static styles = [
    sharedStyles,
    css`
      :host {
        font-size: 17px;
        color: var(--text-color-main);
        height: calc(100vh - 84px);
        max-height: calc(100vh - 84px);
        overflow-y: auto;
        background-color: white;
        z-index: 100;
        padding: 10px;
        padding-left: 30px;
        padding-right: 30px;
      }

      :host([disableButtons]) {
        pointer-events: none;
        opacity: 0.7;
      }

      .row {
        width: 100%;
        display: flex;
        flex-direction: row;
        flex-grow: 1;
      }

      .centered {
        justify-content: center;
      }

      .inner-wrapper {
        max-width: 600px;
        flex-grow: 1;
      }

      .wrapper {
        padding-bottom: 400px;
        display: flex;
        flex-direction: row;
        justify-content: center;
      }

      .close-wrapper {
        padding: 5px;
      }

      .label {
        text-align: left;
        min-width: 180px;
        font-weight: bold;
        flex-grow: 1;
        max-width: 300px;
        margin-top: 20px;
        margin-bottom: 15px;
      }

      .value {
        text-align: right;
        min-width: 100px;
        flex-grow: 1;
        max-width: 300px;
      }

      langhout-button {
        max-width: 150px;
        min-width: 140px;
        margin-right: 20px;
        margin-top: 20px;
      }

      .plus-icon-wrapper {
        margin-top: 20px;
      }

      .email-row {
        margin-top: 10px;
      }
    `,
  ];

  @property({ type: Object, attribute: true, reflect: true })
  public currentEditAccount: Account = <Account>{};

  @property({ type: Boolean, reflect: true })
  private disableButtons = false;

  @query('#automaticallySendPickupConfirmationCheckbox')
  private automaticallySendPickupConfirmationCheckbox?: LanghoutCheckbox;

  constructor() {
    super();
  }

  render() {
    if (!this.currentEditAccount.package_receipt_email_addresses) {
      return html``;
    }
    if (!this.currentEditAccount.pickup_confirmation_email_addresses) {
      this.currentEditAccount.pickup_confirmation_email_addresses = [];
    }
    if (
      this.currentEditAccount.automatically_send_pickup_confirmation ===
      undefined
    ) {
      this.currentEditAccount.automatically_send_pickup_confirmation = false;
    }
    return html`
      <div class="row">
        <div class="fill"></div>
        <div
          class="close-wrapper"
          @click="${() => {
            this.dispatchCloseEvent();
          }}"
        >
          ${closeIcon()}
        </div>
      </div>
      <div class="wrapper">
        <div class="inner-wrapper">
          <h2>${this.currentEditAccount.name}</h2>
          <div class="row">
            <div class="label">Pakbon emailaddressen</div>
            <div class="fill"></div>
            <div
              class="plus-icon-wrapper"
              @click="${() => {
                const temp = this.currentEditAccount;
                temp.package_receipt_email_addresses.push('');
                this.currentEditAccount = <Account>{};
                this.currentEditAccount = temp;
              }}"
            >
              ${plusIcon()}
            </div>
          </div>
          ${repeat(
            this.currentEditAccount.package_receipt_email_addresses,
            email => email,
            (v, i) => {
              return html`
                <div class="row email-row">
                  <input
                    type="email"
                    class="package-receipt-email"
                    value=${v}
                  />
                  <div class="fill"></div>
                  <div
                    @click="${() => {
                      if (
                        this.currentEditAccount.package_receipt_email_addresses
                          .length === 1
                      ) {
                        return;
                      }
                      if (!this.shadowRoot) {
                        return;
                      }

                      const emails = this.shadowRoot.querySelectorAll(
                        '.package-receipt-email',
                      );
                      const newEmails: string[] = [];
                      emails.forEach((e: Element, otherIndex: number) => {
                        if (otherIndex !== i) {
                          const inputElement = <HTMLInputElement>e;

                          newEmails.push(inputElement.value);
                        }
                      });

                      const temp = this.currentEditAccount;
                      temp.package_receipt_email_addresses = newEmails;
                      this.currentEditAccount = <Account>{};
                      this.currentEditAccount = temp;
                    }}"
                  >
                    ${minusIcon()}
                  </div>
                </div>
              `;
            },
          )}
          <div class="row">
            <div class="label">Factuur emailaddressen</div>
            <div class="fill"></div>
            <div
              class="plus-icon-wrapper"
              @click="${() => {
                const temp = this.currentEditAccount;
                temp.invoice_email_addresses.push('');
                this.currentEditAccount = <Account>{};
                this.currentEditAccount = temp;
              }}"
            >
              ${plusIcon()}
            </div>
          </div>
          ${repeat(
            this.currentEditAccount.invoice_email_addresses,
            email => email,
            (v, i) => {
              return html`
                <div class="row email-row">
                  <input type="email" class="invoice-email" value=${v} />
                  <div class="fill"></div>
                  <div
                    @click="${() => {
                      if (
                        this.currentEditAccount.invoice_email_addresses
                          .length === 1
                      ) {
                        return;
                      }
                      if (!this.shadowRoot) {
                        return;
                      }

                      const emails =
                        this.shadowRoot.querySelectorAll('.invoice-email');
                      const newEmails: string[] = [];
                      emails.forEach((e: Element, otherIndex: number) => {
                        if (otherIndex !== i) {
                          const inputElement = <HTMLInputElement>e;

                          newEmails.push(inputElement.value);
                        }
                      });

                      const temp = this.currentEditAccount;
                      temp.invoice_email_addresses = newEmails;
                      this.currentEditAccount = <Account>{};
                      this.currentEditAccount = temp;
                    }}"
                  >
                    ${minusIcon()}
                  </div>
                </div>
              `;
            },
          )}
          <div class="row">
            <div class="label">Pickup bevestiging emailaddressen</div>
            <div class="fill"></div>
            <div
              class="plus-icon-wrapper"
              @click="${() => {
                const temp = this.currentEditAccount;
                temp.pickup_confirmation_email_addresses?.push('');
                this.currentEditAccount = <Account>{};
                this.currentEditAccount = temp;
              }}"
            >
              ${plusIcon()}
            </div>
          </div>
          ${repeat(
            this.currentEditAccount.pickup_confirmation_email_addresses,
            email => email,
            (v, i) => {
              return html`
                <div class="row email-row">
                  <input
                    type="email"
                    class="pickup-confirmation-email"
                    value=${v}
                  />
                  <div class="fill"></div>
                  <div
                    @click="${() => {
                      if (!this.shadowRoot) {
                        return;
                      }

                      const emails = this.shadowRoot.querySelectorAll(
                        '.pickup-confirmation-email',
                      );
                      const newEmails: string[] = [];
                      emails.forEach((e: Element, otherIndex: number) => {
                        if (otherIndex !== i) {
                          const inputElement = <HTMLInputElement>e;
                          newEmails.push(inputElement.value);
                        }
                      });

                      const temp = this.currentEditAccount;
                      temp.pickup_confirmation_email_addresses = newEmails;
                      this.currentEditAccount = <Account>{};
                      this.currentEditAccount = temp;
                    }}"
                  >
                    ${minusIcon()}
                  </div>
                </div>
              `;
            },
          )}
          <div class="row">
            <div class="label">Automatisch pickup bevestiging versturen</div>
            <div class="fill"></div>
            <langhout-checkbox
              id="automaticallySendPickupConfirmationCheckbox"
              .checked=${
                this.currentEditAccount.automatically_send_pickup_confirmation
              }
            ></langhout-checkbox>
          </div>

          <div class="row centered">
            <langhout-button
              text="Opslaan"
              @click="${async () => {
                this.disableButtons = true;
                const error = this.getEmailsFromInputs();
                if (error !== '') {
                  this.disableButtons = false;
                  showNotification(error);
                  return;
                }
                await this.updateAccount();
                this.disableButtons = false;
              }}"
            ></langhout-button>
          </div>
        </div>
      </div>
    `;
  }

  updateAccount = async () => {
    const path = `/accounts/${this.currentEditAccount.id}`;
    const payload = {
      package_receipt_email_addresses:
        this.currentEditAccount.package_receipt_email_addresses,
      pickup_confirmation_email_addresses:
        this.currentEditAccount.pickup_confirmation_email_addresses,
      automatically_send_pickup_confirmation:
        this.automaticallySendPickupConfirmationCheckbox?.checked ?? false,
      invoice_email_addresses: this.currentEditAccount.invoice_email_addresses,
    };
    const result = await authenticatedAPICall(
      path,
      'PUT',
      new Headers(),
      JSON.stringify(payload),
    );
    if (isSuccessfulAPIResponse(result) && result.body.success) {
      showNotification('Account succesvol aangepast!');
      this.dispatchReloadEvent();
    }
  };

  getEmailsFromInputs = (): string => {
    if (!this.shadowRoot) {
      return 'Kan niet updaten';
    }

    const emails = this.shadowRoot.querySelectorAll('.invoice-email');
    const newEmails: string[] = [];
    for (let i = 0; i < emails.length; i++) {
      const inputElement = <HTMLInputElement>emails[i];
      if (inputElement.value === '') {
        return 'Factuur email adres moet worden ingevuld, mag geen lege waarde bevatten';
      }
      newEmails.push(inputElement.value);
    }
    this.currentEditAccount.invoice_email_addresses = newEmails;

    const receiptEmails = this.shadowRoot.querySelectorAll(
      '.package-receipt-email',
    );
    const newReceiptEmails: string[] = [];
    for (let i = 0; i < receiptEmails.length; i++) {
      const inputElement = <HTMLInputElement>receiptEmails[i];
      if (inputElement.value === '') {
        return 'Pakbon email adres moet worden ingevuld, mag geen lege waarde bevatten';
      }
      newReceiptEmails.push(inputElement.value);
    }
    this.currentEditAccount.package_receipt_email_addresses = newReceiptEmails;

    const pickupConfirmationEmails = this.shadowRoot.querySelectorAll(
      '.pickup-confirmation-email',
    );
    const newPickupConfirmationEmails: string[] = [];
    for (let i = 0; i < pickupConfirmationEmails.length; i++) {
      const inputElement = <HTMLInputElement>pickupConfirmationEmails[i];
      if (inputElement.value === '') {
        return 'Pickup bevestiging email adres moet worden ingevuld, mag geen lege waarde bevatten';
      }
      newPickupConfirmationEmails.push(inputElement.value);
    }
    this.currentEditAccount.pickup_confirmation_email_addresses =
      newPickupConfirmationEmails;
    this.currentEditAccount.automatically_send_pickup_confirmation =
      this.automaticallySendPickupConfirmationCheckbox?.checked ?? false;
    return '';
  };

  dispatchReloadEvent = () => {
    const event = new CustomEvent('reload', {
      detail: {},
    });
    this.dispatchEvent(event);
  };

  dispatchCloseEvent = () => {
    const event = new CustomEvent('close', {
      detail: {},
    });
    this.dispatchEvent(event);
  };
}

declare global {
  interface HTMLElementTagNameMap {
    'langhout-beton-edit-account': EditAccount;
  }
}
